import {Registry} from 'constants/RegistryConstants';
import NavStore from 'nav/NavStore';
import {getInitialRegistry} from 'registry/DefaultRegistry';

import {PlateDesignState} from '../AnnotateFillPlateModalConstants';

export const getInitialRegistryForPlateDesign = (
  initialPlateDesignState: PlateDesignState | null | undefined
): Registry | null => {
  const allRegistries = NavStore.getRegistries();

  // If we're coming from a plate design, we already have a schema, so we already know the correct
  // registry.

  const plateSchema = initialPlateDesignState?.plateSchema;
  if (plateSchema != null) {
    return allRegistries.find((registry) => registry.id === plateSchema.registryId)!;
  }
  return getInitialRegistry(allRegistries);
};
